import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import React, { FC } from "react";
import Chip from "shared/components/Chip";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import FieldLabel from "shared/components/Form/components/FieldLabel";
import { COLOR_BLACK, COLOR_GREY_2, COLOR_GREY_6 } from "shared/theme/colors";
import { useMetadataTagDetails } from "../../../../context";
import { StyledSecondaryTagContainer } from "./styled";

const General: FC = () => {
  const { metadataSecondaryTags, metadataTagDescription } =
    useMetadataTagDetails();

  return (
    <ContentSection title="General">
      <Stack spacing="1rem">
        {metadataSecondaryTags.length > 0 && (
          <Box display="flex" flexDirection="column" width="100%">
            <FieldLabel label={"Secondary Tags"} labelColor={COLOR_BLACK} />
            <StyledSecondaryTagContainer display="flex" gap={1}>
              {metadataSecondaryTags.map((tag, idx) => (
                <Chip
                  key={idx}
                  title={tag}
                  bgColor={COLOR_GREY_2}
                  borderColor={COLOR_GREY_6}
                />
              ))}
            </StyledSecondaryTagContainer>
          </Box>
        )}
        <TextField
          id="metadataTagDescription"
          label="Description"
          fullWidth
          placeholder="Description (optional)"
          required
          value={metadataTagDescription?.input.value}
          onChange={(e) => metadataTagDescription?.setValue(e.target.value)}
          labelColor={COLOR_BLACK}
        />
      </Stack>
    </ContentSection>
  );
};

export default General;
